import i18n from '~/i18n';
import Api from '~/stores/providers/Api2';
import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import { trim } from 'ramda';
import validatorjs from 'validatorjs';

class IntegrationAppForm extends Form {
  context: {
    api: Api;
    tenantId: string;
  };

  constructor(data, options, context) {
    super(data, options);
    this.context = context;
  }

  options() {
    return {
      validateOnInit: true,
      validateOnChange: true,
      validateOnBlur: false,
    };
  }

  checkTitle(value, __attr, __key, passes) {
    this.context.api.commandApp
      .validateDuplicatedIntegrationAppName({
        name: trim(value),
        tenantId: this.context.tenantId,
      })
      .then((result) => {
        if (!result) {
          passes();
        } else {
          passes(false, i18n.t('existAppName', '이미 존재하는 앱 입니다  다른 이름으로 지정해 주세요.'));
        }
      });
  }

  /*
    Below we are returning a `plugins` object using the `validatorjs` package
    to enable `DVR` functionalities (Declarative Validation Rules).
  */
  plugins() {
    return {
      dvr: dvr({
        package: validatorjs,
        extend: ({ validator, form }) => {
          const messages = validator.getMessages('en');
          messages['required.name'] = i18n.t('form.rule.name.required', '이름을 입력해 주세요.');
          messages.max = i18n.t('form.rule.max', ':max자 이하로 입력해 주세요.');
          messages.min = i18n.t('form.rule.min', ':min자 이상 입력해 주세요.');
          validator.registerAsync('checkTitle', (value, attr, key, passes) => {
            if (form.$('name').isPristine) {
              passes();
            } else {
              this.checkTitle(value, attr, key, passes);
            }
          });
          validator.setMessages('en', messages);
        },
      }),
    };
  }

  /*
    Return the `fields` as a collection into the `setup()` method
    with a `rules` property for the validation.
  */
  setup() {
    return {
      fields: [
        {
          name: 'name',
          rules: 'required|min:2|max:30|checkTitle',
          value: '',
        },
        {
          name: 'description',
          rules: 'max:200',
          value: '',
        },
        {
          name: 'iconAttachId',
          type: 'file',
          value: '',
        },
        {
          name: 'iconPreviewUrl',
          value: '',
        },
      ],
    };
  }
}

export default IntegrationAppForm;
